import { toast } from "react-toastify";

import { DuplicateExperienceResponseBodyType } from "@intelligems/ig-types";
import {
  RestartExperienceRequestPathParamType,
  RestartExperienceResponseBodyType,
} from "@intelligems/ig-types/functions/experiences/restart-experience";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { experienceKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const restartExperience = async (
  payload: ApiRequest<undefined, RestartExperienceRequestPathParamType>
): Promise<RestartExperienceResponseBodyType> => {
  const resp = await api.post<RestartExperienceResponseBodyType>(
    `/v2/experiences/${payload.pathParams.experienceId}/restart`,
    null
  );
  return resp.data;
};

export const useRestartExperience = (experienceId: string) => {
  const queryClient = useQueryClient();
  return useMutation<
    DuplicateExperienceResponseBodyType,
    Error,
    ApiRequest<any, RestartExperienceRequestPathParamType>
  >({
    mutationFn: async (data) => restartExperience(data),
    onSuccess: async () => {
      void queryClient.invalidateQueries({
        queryKey: experienceKeys.experimentList,
      });
      await queryClient.invalidateQueries({
        queryKey: experienceKeys.one(experienceId),
      });
      toast.success("Experiment Restarted");
    },
  });
};
